export interface TaskTypeClass {
    AccountTaskTypeId : number
    TaskType:string
    AccountId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}

const common = {    
    TaskType:"",
    IsDisabled:false
  };
  export const TaskTypeInitialsForAdd = { ...common };
  
  export const TaskTypeInitialsForUpdate = {
    ...common,
    AccountTaskTypeId: 0
  };
  
